// extracted by mini-css-extract-plugin
module.exports = {"defaultCellStyle":"userGrid_defaultCellStyle__2HCeg","actionsCellStyle":"userGrid_actionsCellStyle__3raze"};